<template>
  <div class="products-management-page">
    <custom-tabs
      v-model="activeTab"
      :tab-items="tabs"
      class="mx-2 my-4 "
      grow
    >
      <template #staticItems>
        <!-- تب اول: محصولات فعال -->
        <v-tab-item>
          <products-list-tab />
        </v-tab-item>

        <!-- تب دوم: آرشیو محصولات -->
        <v-tab-item>
          <archived-products-list-tab />
        </v-tab-item>

      </template>
    </custom-tabs>
  </div>
</template>

<script>
import ProductsListTab from "./ProductsListTab.vue";
import ArchivedProductsListTab from "./ArchivedProductsListTab.vue";

export default {
  name: "ProductsManagementIndex",
  components: {
    ProductsListTab,
    ArchivedProductsListTab,
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          text: "محصولات",
          icon: "package-variant-closed",
        },
        {
          text: "آرشیو محصولات",
          icon: "archive-outline",
        },
         
      ],
    };
  },
};
</script>
